"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicationTypes = void 0;
var PublicationTypes;
(function (PublicationTypes) {
    PublicationTypes["AsSoonAsClipAreReady"] = "AsSoonAsClipAreReady";
    PublicationTypes["ChooseDateAndTime"] = "ChooseDateAndTime";
    PublicationTypes["DecideLater"] = "DecideLater";
})(PublicationTypes = exports.PublicationTypes || (exports.PublicationTypes = {}));
//# sourceMappingURL=producer-event-publication-type.js.map